const OtecAdapters = {

    POST_ENVIAR_DATOS_SOLICITUD: {

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    accion: item.accion || '',
                    nombre_completo: item.nombre_completo || '',
                    num_colegiado: item.num_colegiado || '',
                    titulo_especializado: item.titulo_especializado || '',
                    telefono_contacto: item.telefono_contacto || '',
                    correo: item.correo || '',
                    actividad_profesional: item.actividad_profesional || '',
                    poliza_colegio: item.poliza_colegio || 0,
                    poliza_externa: item.poliza_externa || 0,
                    compania_seguros: item.compania_seguros || '',
                    num_poliza: item.num_poliza || '',
                    importe_cobertura: item.importe_cobertura || 0,
                    primera_visita_gratuita: item.primera_visita_gratuita || 0,
                    acepta_condiciones: item.acepta_condiciones || false,
                    actividades_profesionales: item.actividades_profesionales || [],
                    proyectos: item.proyectos || [],
                    territorios: item.territorios || [],
                };

                return data
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },

        receive: {
            schema: function (item: any = '') {
                return item
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const res = this.schema(dataTemp)

                return res
            }
        },
    },

    POST_OBTENER_DATOS_SOLICITUD: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    id: item.id || '',
                    observaciones_admin: item.observaciones_admin || '',
                    nombre_completo: item.nombre_completo || '',
                    num_colegiado: item.num_colegiado || '',
                    titulo_especializado: item.titulo_especializado || '',
                    telefono_contacto: item.telefono_contacto || '',
                    correo: item.correo || '',
                    actividad_profesional: item.actividad_profesional || '',
                    poliza_colegio: Number(item.poliza_colegio || 0),
                    poliza_externa: Number(item.poliza_externa || 0),
                    compania_seguros: item.compania_seguros || '',
                    num_poliza: item.num_poliza || '',
                    importe_cobertura: item.importe_cobertura || 0,
                    primera_visita_gratuita: Number(item.primera_visita_gratuita || 0),
                    acepta_condiciones: item.acepta_condiciones || false,
                    actividades_profesionales: item.actividades_profesionales || [],
                    proyectos: item.proyectos || [],
                    territorios: item.territorios || [],
                    pdf: item.pdf || null,
                    estado: item.estado || null,
                };  
                return data
            },

            adapter: function (data: any) {
                const dataTemp = data?.data?.data;
                const res = this.schema(dataTemp)
                console.log(res);
                return res
            }
        },
    },

    POST_FIRMAR_DOCUMENTO:{

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    accion: item.accion || '',
                    signature: item.signature || '',
                };

                return data
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },

        receive: {
            schema: function (item: any = '') {
                return item
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const res = this.schema(dataTemp)

                return res
            }
        },
    },

    POST_PRE_FIRMAR_DOCUMENTO:{

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    accion: item.accion || '',
                    certificado: item.certificado || '',
                };

                return data
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },

        receive: {
            schema: function (item: any = '') {
                return item
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const res = this.schema(dataTemp)

                return res
            }
        },
    },

    POST_BAJA_DOCUMENTO:{

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    accion: item.accion || '',
                    solicitud_id: item.solicitud_id || '',
                };

                return data
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },

        receive: {
            schema: function (item: any = '') {
                return item
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const res = this.schema(dataTemp)

                return res
            }
        },
    },
}

export {
    OtecAdapters,
}